import { ApiCallError } from 'app/http/ApiCallError';

export const isNotFoundApiError = (error: unknown): boolean => error instanceof ApiCallError && error.status === 404;
